import { createBrowserHistory } from "history";
import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit'
import { routerMiddleware } from "connected-react-router";
import rootReducer from "./rootReducer";

export const history = createBrowserHistory();

export default configureStore({
    reducer:rootReducer(history),
    middleware:[...getDefaultMiddleware(), routerMiddleware(history)]
})